var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTabSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.72237 0.00914383L3.63452 5.09691H8.72237V0.00914383Z",
    fill: "#00BAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4372 26.0629C24.3556 24.1445 26.9063 23.088 29.6194 23.088C29.7878 23.088 29.9556 23.092 30.1227 23.1001V0H11.1239V7.49812H3.62579V34.978H19.6087C19.5118 34.4111 19.4622 33.832 19.4622 33.2452C19.4622 30.5321 20.5187 27.9814 22.4372 26.0629ZM8.57366 10.5999H25.1749V13.0022H8.57366V10.5999ZM8.57366 15.7036H25.1749V18.106H8.57366V15.7036ZM8.57366 20.8073H25.1749V23.2097H8.57366V20.8073Z",
    fill: "#00BAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1029 27.7619C32.0744 24.7335 27.1643 24.7335 24.1359 27.7619C21.1074 30.7904 21.1074 35.7005 24.1359 38.729C27.1643 41.7574 32.0744 41.7574 35.1029 38.729C38.1314 35.7005 38.1314 30.7904 35.1029 27.7619ZM33.0242 34.4466H30.8205V36.6502H28.4182V34.4466H26.2146V32.0443H28.4182V29.8406H30.8205V32.0443H33.0242V34.4466Z",
    fill: "#00BAC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "#00BAC7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTabSelected);
export default __webpack_public_path__ + "static/media/add-tab-selected.724df75d.svg";
export { ForwardRef as ReactComponent };